import { cn } from '@shared/lib/utils';
import React from 'react';

interface ReportContentProps {
  children: React.ReactNode | React.ReactNode[];
  variant?: 'column' | 'full' | 'appendix';
  size?: 'full' | 'md';
  className?: string;
  downloadMode?: boolean;
}

export default function ReportContent({
  children,
  variant = 'column',
  className,
  size = 'full',
  ...props
}: ReportContentProps) {
  const { downloadMode } = props;

  if (variant === 'column') {
    const childrenArray = children as React.ReactNode[];
    return (
      <div
        className={cn(
          'grid grid-cols-1 lg:min-h-[--content-height] h-full flex-1 lg:grid-cols-12 overflow-hidden bg-gray-00',
          {
            'grid-cols-12 h-[--content-height]': downloadMode,
          },
          className
        )}
      >
        <div className="col-span-6 min-h-[--content-height] space-y-7 p-9">
          {childrenArray[0]}
        </div>
        <div className="col-span-6 min-h-[--content-height] space-y-7 bg-teal-100 p-9 text-primary-800">
          {childrenArray[1]}
        </div>
      </div>
    );
  }

  const childrenNode = children as React.ReactNode;
  return (
    <div
      className={cn(
        'p-9 lg:min-h-[--content-height] flex flex-col flex-1 space-y-7 bg-gray-00',
        {
          'bg-teal-100': variant === 'full',
          'h-[calc(var(--page-height)-var(--title-height))]': downloadMode,
          'max-w-2xl': size === 'md',
          className,
        }
      )}
    >
      {childrenNode}
    </div>
  );
}
